import { LoanTerms } from '../../common/types';
import { ABComparisonState, CalculatorVariant } from '../types';

export function setLoanAmount(
  state: ABComparisonState,
  payload: { value: number; variant: CalculatorVariant }
): ABComparisonState {
  return {
    ...state,
    [payload.variant]: {
      ...state[payload.variant],
      loanAmount: payload.value
    }
  };
}

export function setLoanTerm(
  state: ABComparisonState,
  payload: { value: LoanTerms; variant: CalculatorVariant }
): ABComparisonState {
  return {
    ...state,
    [payload.variant]: {
      ...state[payload.variant],
      loanTerm: payload.value
    }
  };
}

export function setInterestRate(
  state: ABComparisonState,
  payload: { value: number; variant: CalculatorVariant }
): ABComparisonState {
  return {
    ...state,
    [payload.variant]: {
      ...state[payload.variant],
      interestRate: payload.value
    }
  };
}

export function setExtraPayment(
  state: ABComparisonState,
  payload: { value: number; variant: CalculatorVariant }
): ABComparisonState {
  return {
    ...state,
    [payload.variant]: {
      ...state[payload.variant],
      extraPayment: payload.value
    }
  };
}

export function setShowFull(state: ABComparisonState, payload: boolean): ABComparisonState {
  return {
    ...state,
    showFull: payload
  };
}

export function setDefaults(
  state: ABComparisonState,
  initialState: ABComparisonState
): ABComparisonState {
  return {
    ...initialState,
    showFull: true
  };
}
